import { BannerCard, APYText } from '@/shared/components/BannerCard';
import Button from '@/shared/components/flip-ui-kit/Button';
import { useLendingPools } from '@/shared/hooks/useLendingPools';
import ArrowIcon from '@/shared/icons/flip-ui-kit/large/Arrow';

const SupplyBannerCard = ({ onClick }: { onClick: () => void }) => {
  const { maxApy, isLoading } = useLendingPools();

  return (
    <BannerCard
      header="Lend your assets"
      className="h-[168px]"
      headerClassName="font-aeonikMedium text-cf-light-3"
      body={<APYText prefix value={maxApy / 100} className="font-aeonikMedium text-[32px]" />}
      isBodyLoading={isLoading}
      action={
        <Button
          type="primary-standard"
          size="medium"
          iconPos="right"
          icon={<ArrowIcon direction="right" />}
        >
          Supply
        </Button>
      }
      onClick={onClick}
      bannerImg={<img src="/illustration-supply-card.png" alt="Supply" />}
    />
  );
};
export default SupplyBannerCard;
